export const isFirstIndex = (index: number) => index === 0;

export const isLastIndex = <T>(index: number, array: T[]) =>
	index === array.length - 1;
